/**
 * Abstract platform environment.
 *
 * @author Igor Zaporozhets <deadbyelpy@gmail.com>
 * @license GNU GENERAL PUBLIC LICENSE Version 3
 */


'use strict';


/**
 * Minimal environment.
 *
 * @type {{language: string, onFocusDebounceTimeout: number}}
 */
var environment;

if ( PLATFORM === 'BROWSER' ) {
    environment = require('../platforms/browser/environment');
}

if ( PLATFORM === 'MAG' || NANOCORE ) {
    environment = require('../platforms/mag/environment');
}

if ( PLATFORM === 'SMARTTV' ) {
    environment = require('../platforms/smarttv/environment');
}

if ( PLATFORM === 'TIZEN' ) {
    environment = require('../platforms/tizen/environment');
}

if ( PLATFORM === 'WEBOS' ) {
    environment = require('../platforms/smarttv/environment');
}

module.exports = environment;
